import "./menuLeft.css";
import Component from "react-pure-render/component";
import React from "react";
import { Link } from "react-router";
import { IndexLink } from "react-router";
import Isvg from "react-inlinesvg";

export default class MenuLeftDropdown extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { pathname, submenu } = this.props;
    if (
      submenu.get("link") &&
      pathname.substring(0, submenu.get("link").length) === submenu.get("link")
    ) {
      if (
        pathname.substring(
          submenu.get("link").length,
          submenu.get("link").length + 1
        ).length > 0
      ) {
        if (
          pathname.substring(
            submenu.get("link").length,
            submenu.get("link").length + 1
          ) === "/"
        ) {
          this.openDropdown();
        }
      } else {
        this.openDropdown();
      }
    }
  }

  openDropdown = () => {
    const { submenu, parents, actions, menu, history, pathname } = this.props;

    let path = [];
    for (let i = 0; i < parents.length; i++) {
      if (i === 0) {
        path = path.concat(parents[i]);
      } else {
        path = path.concat(["items", parents[i]]);
      }
    }

    let heights = [];
    if (parents.length > 1) {
      let menuItems = menu.menuItems.toJS();
      parents.forEach(function(item, index) {
        if (index === 0) {
          heights = heights.concat(menuItems[item].height);
          menuItems = menuItems[item];
        } else if (item !== "items") {
          if (menuItems["items"][item].height) {
            heights = heights.concat(menuItems["items"][item].height);
          }
          menuItems = menuItems["items"][item];
        }
      });
    }
    heights = heights.concat(this.refs.dropdown.offsetHeight);

    if (!(submenu.get("height") > 0)) {
      heights.forEach(function(item, index) {
        if (heights.length - 1 !== index) {
          if (index === 0) {
            actions.setIsDropdownOpen(
              path[0],
              heights[index] + heights[heights.length - 1]
            );
          } else {
            actions.setIsDropdownOpen(
              path.slice(0, 1 + index * 2),
              heights[index] + heights[heights.length - 1]
            );
          }
        } else {
          if (index === 0) {
            actions.setIsDropdownOpen(path[0], heights[index]);
          } else {
            actions.setIsDropdownOpen(
              path.slice(0, 1 + index * 2),
              heights[index]
            );
          }
        }
      });
      const link = submenu.get("link");
      if (link && pathname.substring(0, link.length) !== link) {
        history.pushState(null, link);
      }
    } else {
      heights.forEach(function(item, index) {
        if (index === 0) {
          actions.setIsDropdownOpen(
            path[0],
            heights[index] - submenu.get("height")
          );
        } else {
          actions.setIsDropdownOpen(
            path.slice(0, 1 + index * 2),
            heights[index] - submenu.get("height")
          );
        }
      });
    }
  };

  render() {
    const { submenu, children, level } = this.props;

    const wrapperStyle = {
      height: submenu.get("height") || 0
    };

    return (
      <li>
        <div
          className={`dropdown-toggle dropdown-toggle-level-${level} ${submenu.get(
            "height"
          ) > 0
            ? "dropdown-open"
            : ""}`}
          onClick={this.openDropdown}
        >
          <Isvg
            className={submenu.getIn(["icon", "className"])}
            src={submenu.getIn(["icon", "source"])}
          />
          {submenu.get("text")}
          <div className="min-rectangle" />
          <Isvg className="icon-arrow" src="/assets/img/icon_arrow.svg" />
        </div>
        <div
          className={`dropdown-wrapper dropdown-wrapper-level-${level} ${submenu.get(
            "height"
          ) > 0
            ? "dropdown-open"
            : ""}`}
          style={wrapperStyle}
        >
          <ul
            className={`dropdown-menu dropdown-menu-level-${level} ${submenu.get(
              "height"
            ) > 0
              ? "dropdown-open"
              : ""}`}
            ref="dropdown"
          >
            {children}
          </ul>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/menuLeftDropdown.react.js